import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

Vue.use(VueApollo);
const httpLink = createHttpLink({
    uri: '/api/graphql',
});

const authLink = setContext((_, { headers }) => {
    const token = Vue.prototype.$keycloak.token

    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : '',
        }
    }
});

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache({
        addTypename: false
    })
});

export const apolloProvider = new VueApollo({
    defaultClient: client,
    errorHandler(error) {
        console.error(error)
    }
});